import Select from '@/components/Select.jsx';

const WizardSelect = ({ ...props }) => {
  return <Select size="lg" {...props} />;
};

export default WizardSelect;
